const GatewayInstructionMutations = {
    setActiveGatewayInstructions(state, gatewayInstructions) {
        state.activeGatewayInstructions = gatewayInstructions.map(gi => ({
            instructionName: gi.instruction_name,
            executionOrder: gi.execution_order,
            args: gi.args,
        }));
    },
    setGatewaysInstructions(state, instructions) {
        state.gatewayInstructions = instructions.map(ins =>  ({
            name: ins.name,
        }))
    }
}

export default GatewayInstructionMutations;